import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './UseBackupCodes.module.scss';

export type UseBackUpCodesProps = {
    onUseBackUpCodes: () => void;
};

const UseBackupCodes = ({ onUseBackUpCodes }: UseBackUpCodesProps) => {
    const { t } = useTranslateLpc('lpc-double-authentication');
    return (
        <div className={css.use_backup}>
            <Text
                html
                htmlText={t('connection.backup-bloc.title')}
                variant={'caption_bold_small'}
                color={'txt-primary'}
                customClass={css.text}
            />

            <Text variant={'footer'} color={'txt-primary'} customClass={css.cta}>
                <span onClick={onUseBackUpCodes}>{t('connection.backup-bloc.link')}</span>
            </Text>
        </div>
    );
};

export default UseBackupCodes;
